import React, { useState } from "react";
import Section from "../components/Section";
import EventoCard from "../components/EventoCard";
import { useCollection } from "../hooks/useCollection";

const Eventos = () => {
  const { docs: eventos, loading } = useCollection('eventos');
  const [paginaActual, setPaginaActual] = useState(1);
  const porPagina = 6;

  const totalPaginas = Math.ceil(eventos.length / porPagina);

  const cambiarPagina = (nuevaPagina) => {
    setPaginaActual(nuevaPagina);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const eventosPagina = eventos.slice(
    (paginaActual - 1) * porPagina,
    paginaActual * porPagina
  );

  return (
    <Section title="Eventos">
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          <div className="card-grid">
            {eventosPagina.map((taller, i) => (
              <EventoCard key={i} taller={taller} />
            ))}
          </div>

          {totalPaginas > 1 && (
            <div className="pagination">
              <button disabled={paginaActual === 1} onClick={() => cambiarPagina(paginaActual - 1)}>
                Anterior
              </button>
              {Array.from({ length: totalPaginas }, (_, i) => (
                <button
                  key={i + 1}
                  className={paginaActual === i + 1 ? "active" : ""}
                  onClick={() => cambiarPagina(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button disabled={paginaActual === totalPaginas} onClick={() => cambiarPagina(paginaActual + 1)}>
                Siguiente
              </button>
            </div>
          )}
        </>
      )}
    </Section>
  );
};

export default Eventos;
